import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import SurveyPaintingComponent from '@/views/private/Survey/components/eqpSurvey/eqpSurvey.vue'
import pdfSurvey from '@/views/private/Survey/components/pdfSurvey/pdfSurvey.vue'
import checklisttableComponent from '@/views/private/Survey/components/checklist/checklisttable.vue'
import surveyepievidenceRepository from '@/shared/http/repositories/business/surveyepievidence'
import surveycriticalactivityRepository from '@/shared/http/repositories/business/surveycriticalactivity'
import aprsurveyRepository from '@/shared/http/repositories/business/aprsurvey'
import cabecalhoPng from '../../../../../../static/img/survey/sem-foto.png'
import SurveyRepository from '@/shared/http/repositories/business/Survey'
import VistoriaEpiRepository from '@/shared/http/repositories/business/surveyEquipment'
import { loading } from '@/shared/utils/UIHelper'
import JSZip from 'jszip'
// import semImagem from '../../../../../../static/img/survey/semImagem'
import { saveAs } from 'file-saver'

const Tabs = {
  Detalhes: 0,
  Equipamentos: 1,
  Imagem: 2
}

export default {
  components: {
    SurveyPaintingComponent,
    checklisttableComponent,
    pdfSurvey
  },
  mixins: [ActionsForm],
  name: 'formsurey',
  props: ['dataDetails'],
  data () {
    return {
      imgSemImg: cabecalhoPng,
      tabIndex: Tabs.Detalhes,
      Pdf: null,
      title: 'Detalhe Supervisão  -',
      status: {
        Mensagem: '',
        Cor: '',
        CorTexto: ''
      },
      dataEpi: [],
      imgEqp: [],
      heightImg: 100,
      buttonAllImg: false,
      buttonDawloImg: true,
      dataImgVistoria: [],
      dataEquipamentos: [],
      Observacao: null,
      atividadeCritica: [],
      apr: [],
      dataStatusApr: [
        {
          color: null,
          mensa: null
        }
      ]
    }
  },
  watch: {
    tabIndex: function (val) {
      if (val === 2) {
        this.GetImg()
      }
    }
  },
  created () {
    this.onLoadImg()
    this.formatStatusVistoria(this.dataDetails.statusvistoria)
    this.GetAtividadeCritica(this.dataDetails.id)
    this.onLoadEquipamento()
    this.getStatusApr(this.dataDetails.aprAplicacao)
  },
  methods: {
    generatePDF (valueCabecalho) {
      this.$refs['surveyPdfQma'].onLoad(valueCabecalho, this.atividadeCritica, this.dataImgVistoria, this.dataEquipamentos)
    },
    onLoadEquipamento () {
      loading.push()
      VistoriaEpiRepository.vistoriaPDF(this.dataDetails.id)
        .then(Response => {
          this.dataEquipamentos = Response.data.data
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    openAprovedVistoria () {
      this.$refs['aprovedVistoria'].show()
    },
    closeAprovedVistoria () {
      this.$refs['aprovedVistoria'].hide()
    },
    onLoadImg () {
      loading.push()
      SurveyRepository.imgVistoria(this.dataDetails.id)
        .then(Response => {
          this.dataImgVistoria = Response.data[0]
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    FormatDate (value) {
      return Tools.FormatDateBrazilian(value)
    },
    formatTitle () {
      return this.title + this.dataDetails.codigoObra
    },
    DownOneImg (obj) {
      let foto = obj.midias.foto
      var zip = new JSZip()
      var img = zip.folder('imagens')
      img.file('img.jpg', foto, {base64: true})
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'img_equipamentos.zip')
      })
    },
    imprimir () {
      loading.push()
      SurveyRepository.GetSurveyPrint(this.dataDetails.id)
        .then(Response => {
          if (Response.data.code > 0) {
            let Pdf = Response.data.data
            let stringPdf = `data:application/pdf;base64,${Pdf}`
            let href = document.createElement('a')
            let name = 'Supervisao-' + this.dataDetails.codigoObra + '.pdf'
            href.href = stringPdf
            href.download = name
            href.click()
            loading.pop()
          }
        })
        .catch(Error => this.onException(Error))
    },
    getStatusApr (value) {
      if (value === 2) {
        this.dataStatusApr.mensa = 'NÃO'
        this.dataStatusApr.color = 'red'
      } else if (value === 3) {
        this.dataStatusApr.mensa = 'DESSELECIONADO'
        this.dataStatusApr.color = 'orange'
      } else if (value === 1) {
        this.dataStatusApr.mensa = 'PARCIALMENTE'
        this.dataStatusApr.color = '#9c8f03'
      } else {
        this.dataStatusApr.mensa = 'SIM'
        this.dataStatusApr.color = '#008148'
      }
    },
    GetAtividadeCritica (vistoriaId) {
      loading.push()
      surveycriticalactivityRepository.VistoriaAtividadesCriticas(vistoriaId)
        .then(Response => {
          this.atividadeCritica = Response.data.data
          this.getApr(Response.data.data)
        })
        .catch(Error => this.onException(Error))
    },
    getApr (obj) {
      const listaid = []
      for (let i = 0; i < obj.length; i++) {
        obj[i].aprAtividadesCriticas.map((Element) => {
          listaid.push(Element.aprId)
        })
      }
      aprsurveyRepository.GetByIds(listaid)
        .then(Response => {
          this.apr = Response.data.data
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    ExibiOlho () {
    },
    changeStatus (value) {
      loading.push()
      SurveyRepository.ChangeStatusVistoria(this.dataDetails.id, value)
        .then(Response => {
          this.dataDetails.statusvistoria = Response.data.data.statusvistoria
          this.dataDetails.responsavelSeguranca = Response.data.data.responsavelSeguranca
          loading.pop()
          this.$refs['aprovedVistoria'].hide()
          this.formatStatusVistoria(this.dataDetails.statusvistoria)
        })
        .catch(Error => this.onException(Error))
    },
    showModal () {
      this.$refs['modal-relatorio'].show()
    },
    hideModal () {
      this.$refs['modal-relatorio'].hide()
    },
    ReprovarObs () {
      loading.push()
      this.dataDetails.ObservacaoReprovado = this.Observacao
      SurveyRepository.ReprovarStatusVistoria(this.dataDetails.id, this.dataDetails)
        .then(Response => {
          this.dataDetails.obsReprovacao = Response.data.data.obsReprovacao
          this.dataDetails.statusvistoria = Response.data.data.statusvistoria
          this.dataDetails.responsavelSeguranca = Response.data.data.responsavelSeguranca
          this.formatStatusVistoria(this.dataDetails.statusvistoria)
          this.hideModalObsReprovacao()
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    hideModalObsReprovacao () {
      this.$refs['modalObs'].hide()
    },
    back () {
      document.location.reload()
    },
    ChekedButtonAllImg () {
      var check = document.querySelectorAll('.checkList')
      let button = false
      if (check.length > 0) {
        check = check.forEach((Element) => {
          if (Element.checked === true) {
            button = true
          }
        })
      }
      this.buttonDawloImg = !button
    },
    chekedAllimg () {
      let check = document.querySelectorAll('.checkList')
      for (var i = 0; i < check.length; i++) {
        check[i].checked = this.buttonAllImg
      }
      this.ChekedButtonAllImg()
    },
    DawnloadApr (hash) {
      let foto = hash
      var zip = new JSZip()
      var img = zip.folder('imagens')
      img.file('img.jpg', foto, {base64: true})
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'img_APR.zip')
      })
    },
    formatStatusVistoria (value) {
      if (value === 0) {
        this.status.Mensagem = 'NÃO ENVIADO'
        this.status.Cor = 'rgb(192, 192, 192)'
        this.status.CorTexto = 'rgb(106, 106, 106)'
      }
      if (value === 1) {
        this.status.Mensagem = 'AG. APROVAÇÃO'
        this.status.Cor = 'rgb(212, 238, 253)'
        this.status.CorTexto = 'rgb(0, 55, 137)'
      }
      if (value === 2) {
        this.status.Mensagem = 'AG. CORREÇÃO'
        this.status.Cor = '#ffeadc'
        this.status.CorTexto = 'rgb(255 96 0 / 92%)'
      }
      if (value === 3) {
        this.status.Mensagem = 'APROVADO'
        this.status.Cor = '#cbe9cf'
        this.status.CorTexto = 'rgb(19, 59, 26)'
      }
    },
    AdicionarObs () {
      this.Observacao = this.dataDetails.obsReprovacao
      this.$refs['modalObs'].show()
    },
    formatApr (value) {
      if (value === 3) return 'Desselecionado'
      if (value === 0) return 'Sim'
      if (value === 2) return 'Não'
      if (value === 1) return 'Parcialmente'
    },
    GetImg () {
      loading.push()
      surveyepievidenceRepository.GetAllImgByVistoria(this.dataDetails.id)
        .then(Response => {
          this.imgEqp = Response.data.data
          if (this.imgEqp.length / 13 >= 1) {
            this.heightImg = 120
            let itemFaltando = this.imgEqp.length - 12
            let colunaAdd = itemFaltando / 4
            if (colunaAdd >= 2) {
              let ColunaMax = 20 * Math.ceil(colunaAdd)
              this.heightImg += ColunaMax
            }
          }
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    downloadImg () {
      let check = document.querySelectorAll('.checkList')
      let allimg = []
      check.forEach((element) => {
        if (element.checked === true) {
          allimg.push(element._value.midias.foto)
        }
      })
      var zip = new JSZip()
      var img = zip.folder('imagens')
      for (let i = 0; i < allimg.length; i++) {
        img.file('img' + i + '.jpg', allimg[i], {base64: true})
      }
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'img_equipamentos.zip')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/formSurvey/formSurvey.js